import {
  PAYMENT_TYPE_AMEX,
  PAYMENT_TYPE_DINERS,
  PAYMENT_TYPE_DISCOVER,
  PAYMENT_TYPE_MC,
  PAYMENT_TYPE_VISA,
  PAYMENT_TYPE_STAR,
  PAYMENT_TYPE_NYCE,
  PAYMENT_TYPE_PULSE,
} from 'webapp-common-ui/src/constants';

export default function getCardTypeFromBrand(cradBrand) {
  switch (cradBrand) {
    case 'AMEX':
      return PAYMENT_TYPE_AMEX;

    case 'DINERS':
      return PAYMENT_TYPE_DINERS;

    case 'DISCOVER':
    case 'DISCOVER_NETWORK':
      return PAYMENT_TYPE_DISCOVER;

    case 'MC':
      return PAYMENT_TYPE_MC;

    case 'NYCE':
      return PAYMENT_TYPE_NYCE;

    case 'PULSE':
      return PAYMENT_TYPE_PULSE;

    case 'STAR':
      return PAYMENT_TYPE_STAR;

    case 'VISA':
      return PAYMENT_TYPE_VISA;

    default:
      return 'default';
  }
}
